<template>
	<az-container class="mb-1 ml-0 pa-7" fluid>
		<h3 class="color-titulo font-weight-bold color title">
			Anexos
			<span v-if="possuiDocumentosObrigatorios" class="red--text">*</span>
		</h3>

		<v-row v-if="possuiTiposDocumento">
			<v-col cols="12" class="mt-4">
				<div class="w-450 mx-auto" v-if="podeHabilitarCampo()">
					<label-personalizado
						nome-campo="Escolha o tipo de documento"
						:obrigatorio-por-padrao="possuiDocumentosObrigatorios"
					></label-personalizado>
					<v-autocomplete
						id="tipoDocumento"
						v-model="tipoDocumento"
						:items="tiposDatasource"
						placeholder="Selecione"
						item-value="id"
						item-text="nome"
						dense
						clearable
					></v-autocomplete>
				</div>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12" class="mt-4">
				<alert-card
					v-if="podeHabilitarCampo() && possuiDocumentosObrigatorios"
					class="w-450 mx-auto"
					texto-titulo="Documentos Obrigatórios"
				>
					<div>
						<ul>
							<li v-for="tipoObrigatorio in tiposObrigatorios" :key="tipoObrigatorio.id">
								<texto-tooltip :texto="tipoObrigatorio.nome" :tamanho-maximo="50"></texto-tooltip>
							</li>
						</ul>
					</div>
				</alert-card>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12" class="my-4">
				<campo-arquivo-novo
					v-if="podeHabilitarCampo()"
					class="w-250 ml-auto mr-auto"
					id="modal-novo-anexo-campo-arquivo"
					name="Arquivo"
					v-model="arquivoTemporario"
					:extensoes-permitidas="EXTENSOES_ARQUIVO"
					:label-extensoes-permitidas="LABEL_EXTENSOES_ARQUIVO"
					:errorUpload.sync="errorUpload"
					multiplo-arquivos
					show-selected
					@input="tratarEventoAnexoSelecionado"
				></campo-arquivo-novo>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12" sm="12" class="my-4">
				<listagem-anexos-adesao-view
					:itens="anexos"
					:total-paginas="totalPaginas"
					:total-itens="totalItens"
					:paginacao="paginacao"
					@paginar="setPaginacao"
					@resetar-page="resetarPaginaItemListagem"
				></listagem-anexos-adesao-view>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12" sm="12" class="d-flex flex-column">
				<botao-primario
					:disabled="!isCamposObrigatoriosPreenchidos()"
					id="enviar-adesao-externa"
					class="align-self-end"
					nome-botao="Enviar"
					cor-de-fundo="primary"
					@click="enviarSolicitacaoAdesao"
				></botao-primario>
			</v-col>
		</v-row>
	</az-container>
</template>
<script>
import { mapState } from 'vuex'
import { actionTypes } from '@/core/constants'
import { Alert } from '@/core/utils'
import CampoArquivoNovo from '@/views/components/CampoArquivoNovo.vue'
import ListagemAnexosAdesaoView from '@/views/pages/adesao/publica/anexos/listar-anexos/listagem/ListagemAnexosAdesaoView.vue'
import mutationTypes from '@/core/constants/mutation-types'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import AlertCard from '@/views/components/AlertCard.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import TextoTooltip from '@/views/components/TextoTooltip.vue'

export default {
	name: 'anexo-solicitante-view',
	components: {
		TextoTooltip,
		LabelPersonalizado,
		AlertCard,
		BotaoPrimario,
		ListagemAnexosAdesaoView,
		CampoArquivoNovo,
	},
	data() {
		return {
			errorUpload: false,
			EXTENSOES_ARQUIVO: ['application/pdf'],
			LABEL_EXTENSOES_ARQUIVO: ['pdf'],
			alert: new Alert(this.$store),
			arquivoTemporario: null,
			paginacao: this.$store.state.adesaoPublica.anexos.paginacao,
			tipoDocumento: null,
			tiposDatasource: [],
			tiposObrigatorios: [],
		}
	},
	computed: {
		...mapState({
			isFormAderenteValid: (state) => state.adesaoPublica.formIsValid,
			idSolicitacaoAdesao: (state) => state.adesaoPublica.idSolicitacaoAdesao,
			datasource: (state) => state.adesaoPublica.datasource,
			idAta: (state) => state.adesaoPublica.filtro.idAta,
			anexos: (state) => state.adesaoPublica.anexos.datasource,
			totalPaginas: (state) => state.adesaoPublica.anexos.totalPaginas,
			totalItens: (state) => state.adesaoPublica.anexos.totalItens,
		}),
		possuiDocumentosObrigatorios() {
			return this.tiposObrigatorios.length > 0
		},
		possuiTiposDocumento() {
			return this.tiposDatasource.length > 0
		},
	},
	async mounted() {
		await this.buscarTiposDocumento()
	},
	methods: {
		async tratarEventoAnexoSelecionado(anexoSelecionado) {
			if (!anexoSelecionado || !this.isExtensaoArquivoPermitida(anexoSelecionado)) return

			await this.adicionarAnexo(anexoSelecionado)
		},
		async adicionarAnexo(anexo) {
			await this.$store
				.dispatch(actionTypes.ADESAO_PUBLICA.SALVAR_ANEXO_SOLICITANTE, this.criarPayload(anexo))
				.then(() => this.alert.showSuccess(`Anexo salvo com sucesso!`))
			await this.carregarAnexos()
			this.tipoDocumento = null
		},
		isExtensaoArquivoPermitida(anexo) {
			if (this.EXTENSOES_ARQUIVO.some((extensao) => extensao === anexo.type)) return true

			this.alert.showError(`Formato de arquivo não aceito.`)
			return false
		},
		podeHabilitarCampo() {
			return this.isFormAderenteValid && this.quantidadeItensIsPreenchido()
		},
		quantidadeItensIsPreenchido() {
			return this.datasource.some((item) => item.quantidadeSolicitada)
		},
		criarPayload(anexo) {
			const payload = {
				idAta: this.idAta.value,
				idSolicitacaoAdesao: this.idSolicitacaoAdesao.value,
				anexo,
			}

			if (this.tipoDocumento) {
				payload.idTipoDocumento = this.tipoDocumento
			}

			return payload
		},
		async carregarAnexos() {
			const retorno = await this.$store.dispatch(actionTypes.ADESAO_PUBLICA.BUSCAR_ANEXOS_POR_FILTRO, {
				idAta: this.idAta.value,
				idSolicitacaoAdesao: this.idSolicitacaoAdesao.value,
				paginacao: this.paginacao,
			})

			this.$store.commit(mutationTypes.ADESAO_PUBLICA.SET_INFORMACOES_ANEXOS, retorno)
		},
		setPaginacao(paginacao) {
			this.$store.commit(mutationTypes.ADESAO_PUBLICA.SET_PAGINACAO_LISTAGEM, paginacao)
			this.carregarAnexos()
		},
		resetarPaginaItemListagem() {
			this.$store.commit(mutationTypes.ADESAO_PUBLICA.RESETAR_PAGINA_LISTAGEM)
		},
		async enviarSolicitacaoAdesao() {
			await this.$store
				.dispatch(actionTypes.ADESAO_PUBLICA.ENVIAR_SOLICITACAO_ADESAO, {
					idAta: this.idAta.value,
					idSolicitacaoAdesao: this.idSolicitacaoAdesao.value,
				})
				.then(() => this.notificarSucesso())
		},
		notificarSucesso() {
			this.alert.showSuccess(`Solicitação de adesão enviada com sucesso!`)
			setTimeout(() => location.reload(), 2000)
		},
		isCamposObrigatoriosPreenchidos() {
			return this.isFormAderenteValid && this.quantidadeItensIsPreenchido()
		},
		async buscarTiposDocumento() {
			const { tiposAreaPublica, tiposObrigatorios } = await this.$store.dispatch(
				actionTypes.TIPOS_DOCUMENTO.BUSCAR,
			)

			this.tiposDatasource = tiposAreaPublica
			this.tiposObrigatorios = tiposObrigatorios

			if (tiposAreaPublica.length === 1) {
				this.tipoDocumento = tiposAreaPublica[0].id
			}
		},
	},
}
</script>

<style lang="stylus" scoped>
.w-250
	width 350px

.w-450
	width 450px
</style>
